import Client from './KomodoClient';
import { PAGE_ALL, pagerRows } from './Resource';

// komodo raw-materials connector: menu items ↔ cost cards (api/costcard) and synced POS orders
// (api/kangroo-order). Komodo.SCM.Web/Controllers/Api/CB/*.
const enc = encodeURIComponent;

// PosMenuItemQC { deptCode, itemCode, searchText } → PagerRecord<PosMenuItemListDTO>
const menuItems = (query) =>
	Client.post('/api/costcard/query-pager', {
		...PAGE_ALL,
		pageItems: 500,
		...(query || {}),
	}).then(pagerRows);
// { itemCode, kind, deptCode } → CostCardMainDTO (empty items when none yet)
const costCard = (itemCode, kind, deptCode) =>
	Client.post('/api/costcard/query-one', {
		itemCode,
		kind: Number(kind) || 0,
		deptCode,
	});
// CostCardMainReq → SaveBillOperationResult
const createCostCard = (req) => Client.post('/api/costcard', req);
const updateCostCard = (id, req) => Client.put(`/api/costcard/${enc(id)}`, req);

// PosOrderQC { deptCode, orderNo, orderDateStart, orderDateEnd } → PagerRecord<PosOrderHListDTO>
const orders = (query) =>
	Client.post('/api/kangroo-order/query-pager', {
		...PAGE_ALL,
		pageItems: 500,
		...(query || {}),
	}).then(pagerRows);
const order = (id) => Client.get(`/api/kangroo-order/${enc(id)}`);

// MaterialReferQuery { deptCode, materialCode, billCode } → MaterialReferInfoDTO (units etc.)
const materialRefer = (deptCode, materialCode, billCode = '1061') =>
	Client.post('/api/material/refer/query-one', {
		deptCode,
		materialCode,
		billCode,
	});

export default {
	menuItems,
	costCard,
	createCostCard,
	updateCostCard,
	orders,
	order,
	materialRefer,
};
